const state = {
  parentRoute: '',
  childRoute: '',
};

const mutations = {
  SET_PARENT_ROUTE(state, route) {
    state.parentRoute = route;
  },
  SET_CHILD_ROUTE(state, route) {
    state.childRoute = route;
  },
};

const getters = {
  parentRoute: state => state.parentRoute,
  childRoute: state => state.childRoute,
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
};
